import { PublicClientApplication, EventType } from '@azure/msal-browser';
import store from '../store';

// Config object to be passed to Msal on creation
const msalConfig = {
  auth: {
    clientId: '230da50c-59f5-4aee-99db-1728e30dd415',
    // eslint-disable-next-line max-len
    authority: 'https://login.microsoftonline.com/634e9305-c233-4697-a9a5-cf7955db3f32',
    redirectUri: `${window.location.origin}/products`,
  },
};

const scopes = ['user.read', 'email'];

let msalInstance;

export function init() {
  msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.handleRedirectPromise().then((tokenResponse) => {
    if (!tokenResponse) {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        msalInstance.loginRedirect({
          scopes,
        });
      } else {
        msalInstance.setActiveAccount(accounts[0]);
        store.dispatch('setSignedIn', true);
      }
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
        store.dispatch('setSignedIn', true);
      }
    }
    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
      }
    });
  });
}

export function getActiveAccount() {
  return msalInstance.getActiveAccount();
}

export function isSignedIn() {
  return !!getActiveAccount();
}

export async function getToken() {
  const account = getActiveAccount();
  if (!account) {
    return null;
  }

  const response = await msalInstance.acquireTokenSilent({
    account,
    scopes,
  });
  return response.idToken;
}

export function signInIfNeeded() {
  if (!isSignedIn()) {
    msalInstance.loginRedirect({
      scopes,
    });
  }
}

export function signOut() {
  msalInstance.logoutRedirect({
    scopes,
  });
}



// WEBPACK FOOTER //
// ./common/auth.js